import React, { useState, useEffect } from 'react';
import { FiX } from 'react-icons/fi';

const GroupSettingsModal = ({ isOpen, onClose, group, token, onUpdate }) => {
  const [formData, setFormData] = useState(group || {});
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (isOpen && group) {
      setFormData(group);
    }
  }, [isOpen, group]);

  if (!isOpen || !group) return null;

  const handleUpdate = async () => {
    setLoading(true);
    try {
      const response = await fetch(`${process.env.REACT_APP_BACKEND_URL}/api/groups/${group.id}`, {
        method: 'PUT',
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          name: formData.name,
          color: formData.color,
          order: formData.order
        })
      });
      
      if (response.ok) {
        onUpdate();
        onClose();
      }
    } catch (error) {
      console.error('Failed to update group:', error);
    } finally {
      setLoading(false);
    }
  };

  const colors = [
    { name: 'Blue', value: '#4F8DFF' },
    { name: 'Purple', value: '#9B6BFF' },
    { name: 'Green', value: '#1DBF73' },
    { name: 'Orange', value: '#F4A340' },
    { name: 'Red', value: '#E24B5B' },
    { name: 'Teal', value: '#66ccff' },
    { name: 'Pink', value: '#ff5ac4' },
    { name: 'Yellow', value: '#ffcb00' },
  ];

  return (
    <div className="modal-overlay">
      <div className="modal">
        <div className="modal-header">
          <h2 className="modal-title">Group Settings</h2>
          <button className="modal-close" onClick={onClose}>
            <FiX size={20} />
          </button>
        </div>
        <div className="modal-body">
          <div className="form-group">
            <label className="form-label">Group Name</label>
            <input
              type="text"
              className="input"
              value={formData.name || ''}
              onChange={(e) => setFormData({ ...formData, name: e.target.value })}
              data-testid="group-settings-name"
            />
          </div>
          <div className="form-group">
            <label className="form-label">Group Color</label>
            <div style={{ display: 'flex', gap: '8px', flexWrap: 'wrap' }}>
              {colors.map((color) => (
                <div
                  key={color.value}
                  onClick={() => setFormData({ ...formData, color: color.value })}
                  style={{
                    width: '40px',
                    height: '40px',
                    borderRadius: '6px',
                    backgroundColor: color.value,
                    cursor: 'pointer',
                    border: formData.color === color.value ? '3px solid #323338' : '2px solid transparent',
                    transition: 'all 0.2s ease'
                  }}
                  title={color.name}
                  data-testid={`group-color-${color.name.toLowerCase()}`}
                ></div>
              ))}
            </div>
          </div>
          <div className="form-group">
            <label className="form-label">Sort Order</label>
            <input
              type="number"
              className="input"
              value={formData.order || 1}
              onChange={(e) => setFormData({ ...formData, order: parseInt(e.target.value) || 1 })}
              min="1"
              data-testid="group-order-input"
            />
            <p className="form-helper">Lower numbers appear first</p>
          </div>
        </div>
        <div className="modal-footer">
          <button className="btn btn-secondary" onClick={onClose} disabled={loading}>
            Cancel
          </button>
          <button className="btn btn-primary" onClick={handleUpdate} disabled={loading}>
            {loading ? 'Saving...' : 'Save Changes'}
          </button>
        </div>
      </div>
    </div>
  );
};

export default GroupSettingsModal;